import Socials from '../Socials/Socials';
import './MainBody.css';
function MainBody() {
    return (
    <div class="BodyFlex">
        <div class="ExecutiveSummary">
            <div class="SummaryText">Driven computer science and math graduate with a 3.7 GPA. Passionate about building web applications using the MERN stack, diving deep into the Linux operating system and embedded systems using the C programming language, and delivering tech solutions to others in the role of a tech educator. Worked with agile, diverse software teams to deliver satisfactory results for every stakeholder. </div>
        </div>
        <Socials/>
     </div> 
    );
}
export default MainBody;